import { Box, Button, Flex, FormControl, FormLabel, IconButton, Input, Text, useToast } from '@chakra-ui/react';
import { DeleteIcon } from '@chakra-ui/icons';
import { useState } from 'react';
import { resolveCatalogReceiver } from 'services/api.service';

export interface SplitRowValue {
  lookup: string;
  receiverCustomerId: string;
  receiverName: string;
  percentage: number | string;
}

interface Props {
  value: SplitRowValue;
  onChange: (patch: Partial<SplitRowValue>) => void;
  onRemove: () => void;
}

export default function SplitRow({ value, onChange, onRemove }: Props) {
  const toast = useToast();
  const [resolving, setResolving] = useState(false);

  const resolve = async () => {
    const raw = (value.lookup || '').trim();
    if (!raw) return;
    setResolving(true);
    try {
      const isEmail = raw.includes('@');
      const data = await resolveCatalogReceiver(isEmail ? { email: raw } : { account: raw });
      onChange({ receiverCustomerId: data.customerId, receiverName: data.name });
    } catch (err: any) {
      onChange({ receiverCustomerId: '', receiverName: '' });
      toast({
        title: 'Recebedor não encontrado',
        description: err?.response?.data?.message || 'Verifique o email ou número da conta',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setResolving(false);
    }
  };

  return (
    <Box borderWidth="1px" borderRadius="md" p={3}>
      <Flex gap={2} align="flex-end" wrap="wrap">
        <FormControl flex="2" minW="200px">
          <FormLabel fontSize="sm">Email ou nº da conta</FormLabel>
          <Input
            size="sm"
            value={value.lookup}
            onChange={(e) => onChange({ lookup: e.target.value, receiverCustomerId: '', receiverName: '' })}
            placeholder="fulano@email.com ou 12345"
          />
        </FormControl>
        <Button size="sm" onClick={resolve} isLoading={resolving} variant="outline">
          Verificar
        </Button>
        <FormControl flex="1" minW="90px">
          <FormLabel fontSize="sm">%</FormLabel>
          <Input
            size="sm"
            type="number"
            value={value.percentage}
            onChange={(e) => onChange({ percentage: e.target.value })}
            placeholder="0"
          />
        </FormControl>
        <IconButton
          aria-label="Remover"
          icon={<DeleteIcon />}
          size="sm"
          colorScheme="red"
          variant="outline"
          onClick={onRemove}
        />
      </Flex>
      {value.receiverName ? (
        <Text mt={1} fontSize="sm" color="green.500">
          ✓ {value.receiverName}
        </Text>
      ) : value.lookup ? (
        <Text mt={1} fontSize="sm" color="orange.500">
          Clique em Verificar para confirmar o recebedor
        </Text>
      ) : null}
    </Box>
  );
}
